module.exports = __webpack_public_path__ + "img/bgp02.8db035c2.jpg";